import { registerCTADefaultData } from "@/components/CTA/variants/Register";
import { useMonarchRule } from "../MonarchRulesProvider";
import { RegisterCTATestData, UseRegisterCTA } from "./types";

const CUSTOM_RULE_ID = "registerCtaTest";

const useRegisterCTA: UseRegisterCTA = () => {
  const { isLoading, value } = useMonarchRule<{
    data: RegisterCTATestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        enableTest: false,
        showRegisterAtBottom: false,
        ...registerCTADefaultData,
      },
    };
  }

  const variant = value?.data?.enableTest ? "test" : "control";

  return {
    isLoading,
    variant,
    data: {
      enableTest: value?.data?.enableTest,
      title: value?.data?.title ?? registerCTADefaultData.title,
      subtitle: value?.data?.subtitle ?? registerCTADefaultData.subtitle,
      ctaText: value?.data?.ctaText ?? registerCTADefaultData.ctaText,
      showRegisterAtBottom: value?.data?.showRegisterAtBottom ?? false,
    },
  };
};

export default useRegisterCTA;
